import { ValueOf } from './common/utils/typeUtils'

export const PLATFORM_BASENAME = 'clipro'

export const MEDIA_TYPES = Object.freeze({
  ASSETS: 'clips', // In the future change the value to 'assets' (today it breaks the BE download API and maybe some more API we send the item _type )
  CLIP_IT: 'clipit',
  UPLOADED_VIDEOS: 'uploadedVideos',
  PBP: 'pbp',
  VIDEOS: 'videos',
  AUDIOS: 'audios',
  UPLOADED_AUDIOS: 'uploadedAudios',
  EXTRACTED_AUDIOS: 'extractedAudios',
  MOMENTS: 'moments',
  STORIES: 'stories',
  EXTRACTED_IMAGES: 'extractedImages',
  UPLOADED_IMAGES: 'uploadedImages',
  EXTRACTED_GIFS: 'extractedGifs',
  UPLOADED_GIFS: 'uploadedGifs',
  GRAPHIC_VIDEOS: 'graphicVideos',
  GRAPHIC_IMAGES: 'graphicImages',
  STREAM_SEGMENTS: 'streamSegments',
} as const)

export const VIDEOS_SEARCH_ITEM_TYPE = Object.freeze({
  VIDEO: 1,
  STORY: 2,
} as const)

export const TEXT_TO_VIDEO_MODE = Object.freeze({
  GETTY: 'getty',
  PBP: 'pbp',
  GETTY_PBP: 'getty-pbp',
} as const)

export const ASPECT_RATIO_FILTER_NAME = 'Ratio'

export const ASPECT_RATIO = Object.freeze({
  HORIZONTAL: 'Horizontal',
  SQUARE: 'Square',
  FOUR_TO_FIVE: 'FourToFive',
  VERTICAL: 'Vertical',
  TWO_TO_THREE: 'TwoToThree',
  THREE_TO_FOUR: 'ThreeToFour',
  FOUR_TO_THREE: 'FourToThree',
  TWO_TO_ONE: 'TwoToOne',
  ONE_TO_TWO: 'OneToTwo',
  SEVEN_TO_EIGHT: 'SevenToEight',
  EIGHT_TO_SEVEN: 'EightToSeven',
  THREE_TO_ONE: 'ThreeToOne',
  THREE_TO_TWO: 'ThreeToTwo',
  ONE_TO_THREE: 'OneToThree',
} as const)

export const ASPECT_RATIO_DISPLAY = Object.freeze({
  [ASPECT_RATIO.HORIZONTAL]: '16:9',
  [ASPECT_RATIO.SQUARE]: '1:1',
  [ASPECT_RATIO.FOUR_TO_FIVE]: '4:5',
  [ASPECT_RATIO.VERTICAL]: '9:16',
  [ASPECT_RATIO.TWO_TO_THREE]: '2:3',
  [ASPECT_RATIO.THREE_TO_FOUR]: '3:4',
  [ASPECT_RATIO.FOUR_TO_THREE]: '4:3',
  [ASPECT_RATIO.TWO_TO_ONE]: '2:1',
  [ASPECT_RATIO.ONE_TO_TWO]: '1:2',
  [ASPECT_RATIO.SEVEN_TO_EIGHT]: '7:8',
  [ASPECT_RATIO.EIGHT_TO_SEVEN]: '8:7',
  [ASPECT_RATIO.THREE_TO_ONE]: '3:1',
  [ASPECT_RATIO.THREE_TO_TWO]: '3:2',
  [ASPECT_RATIO.ONE_TO_THREE]: '1:3',
} as const)

export const GAME_TYPE = Object.freeze({
  BASKETBALL: 'basketball',
  CRICKET: 'cricket',
  FOOTBALL: 'football2',
  GOLF: 'golf',
  SOCCER: 'soccer2',
  SURFING: 'surfing',
  TENNIS: 'tennis',
  SKI: 'ski',
  UFC: 'ufc',
  SKATEBOARDING: 'skateboarding',
} as const)

export const GAME_CONTENT_TYPE = Object.freeze({
  GAME: 'Game',
  LIVE_CHANNEL: 'LiveChannel',
  PROGRAM: 'Program',
  FICTIVE: 'Fictive',
  AUDIO: 'Audio',
} as const)

export const FILE_SOURCE_OPTIONS = Object.freeze({
  CLIPPED_FROM_STREAM: GAME_CONTENT_TYPE.GAME,
  CLIPS: GAME_CONTENT_TYPE.FICTIVE,
  UPLOADED_AUDIO: 'Uploaded Audio',
  EXTRACTED_AUDIO: 'Extracted Audio',
  EXTRACTED_IMAGE: 'Extracted Image',
  UPLOADED_IMAGE: 'Uploaded Image',
  GRAPHICS_VIDEOS: 'Video Graphics',
  GRAPHICS_IMAGES: 'Image Graphics',
  EXTRACTED_GIF: 'Extracted GIF',
  UPLOADED_GIF: 'Uploaded GIF',
} as const)

export const GRAPHICS_TEMPLATE_INFO_KEYS = Object.freeze({
  RATIO_TYPES: 'ratioTypes',
  TEMPLATE_ID: 'templateId',
} as const)

export const FILE_SOURCE_OPTIONS_DISPLAY = Object.freeze({
  [FILE_SOURCE_OPTIONS.CLIPPED_FROM_STREAM]: 'Clipped Video',
  [FILE_SOURCE_OPTIONS.CLIPS]: 'Uploaded Video',
  [FILE_SOURCE_OPTIONS.UPLOADED_AUDIO]: 'Uploaded Audio',
  [FILE_SOURCE_OPTIONS.EXTRACTED_AUDIO]: 'Extracted Audio',
  [FILE_SOURCE_OPTIONS.EXTRACTED_IMAGE]: 'Extracted Images',
  [FILE_SOURCE_OPTIONS.UPLOADED_IMAGE]: 'Uploaded Images',
  [FILE_SOURCE_OPTIONS.GRAPHICS_VIDEOS]: 'Graphics - Videos',
  [FILE_SOURCE_OPTIONS.GRAPHICS_IMAGES]: 'Graphics - Images',
  [FILE_SOURCE_OPTIONS.UPLOADED_GIF]: 'Uploaded GIF',
  [FILE_SOURCE_OPTIONS.EXTRACTED_GIF]: 'Extracted GIF',
} as const)

export const NON_ONE_VS_ONE_GAME_TYPES = Object.freeze([GAME_TYPE.GOLF, GAME_TYPE.SURFING] as const)

export const STREAM_TYPE = Object.freeze({
  CHANNEL: 'channel',
  GAME: 'game',
  PROGRAM: 'program',
} as const)

// Corrospondes to 'GameContentType' enum in Zoominsite
export const STREAM_TYPE_NUMBER = Object.freeze({
  GAME: 1,
  CHANNEL: 2,
  PROGRAM: 3,
} as const)

export const SHOW_TYPE = STREAM_TYPE

export const SETTINGS_DISPLAY_OPTIONS = Object.freeze({
  SHOW: 'Show',
  DISABLE: 'Disable',
  HIDE: 'Hide',
} as const)

export const ASSET_TYPE = Object.freeze({
  CLIP: 'clip',
  GIF: 'gif',
  STORY: 'story',
  AUDIO: 'audio',
  IMAGE: 'image',
  GRAPHICS_IMAGE: 'graphics image',
  GRAPHICS_VIDEO: 'graphics video',
  UPLOADED_IMAGE: 'uploaded image',
} as const)

export const FETCHED_GRAPHIC_ASSET_TYPE = Object.freeze({
  GRAPHICS_IMAGE: 'GraphicImage',
  GRAPHICS_VIDEO: 'GraphicVideo',
} as const)

export const MAP_MEDIA_TYPES_TO_FETCHED_ASSET_TYPE = Object.freeze({
  [MEDIA_TYPES.GRAPHIC_IMAGES]: FETCHED_GRAPHIC_ASSET_TYPE.GRAPHICS_IMAGE,
  [MEDIA_TYPES.GRAPHIC_VIDEOS]: FETCHED_GRAPHIC_ASSET_TYPE.GRAPHICS_VIDEO,
} as const)

export const ASSETS_SEARCH_ITEM_TYPE_OLD = Object.freeze({
  CLIP: 0,
  AUDIO: 1,
} as const)

export const ASSETS_SEARCH_ITEM_TYPE_NEW = Object.freeze({
  CLIP_FROM_STREAM: 0,
  UPLOADED_CLIP: 1,
  UPLOADED_AUDIO: 2,
  EXTRACTED_IMAGE: 3,
  EXTRACTED_GIF: 4,
  GRAPHIC_IMAGE: 5,
  GRAPHIC_VIDEO: 6,
  STORY: 7,
  PBP: 8,
  AUTOMATIC_VIDEO: 9,
  USER_VIDEO: 10,
  UPLOADED_IMAGE: 11,
  EXTRACTED_AUDIO: 12,
  RECOMMENDATION: 13,
  FOLDER: 14,
  CLIP_IT: 15,
  UPLOADED_VIDEO: 16,
  UPLOADED_GIF: 17,
  STREAM_SEGMENT: 18,
} as const)

// currently only "videos" service returns enum values as strings
// ideally, all services should return (and get) enum values as strings
export const ASSETS_SEARCH_ITEM_TYPE_NEW_FROM_STRING = Object.freeze({
  ClipFromStream: ASSETS_SEARCH_ITEM_TYPE_NEW.CLIP_FROM_STREAM,
  UploadedClip: ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_CLIP,
  UploadedAudio: ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_AUDIO,
  ExtractedImage: ASSETS_SEARCH_ITEM_TYPE_NEW.EXTRACTED_IMAGE,
  ExtractedGif: ASSETS_SEARCH_ITEM_TYPE_NEW.EXTRACTED_GIF,
  GraphicImage: ASSETS_SEARCH_ITEM_TYPE_NEW.GRAPHIC_IMAGE,
  GraphicVideo: ASSETS_SEARCH_ITEM_TYPE_NEW.GRAPHIC_VIDEO,
  Story: ASSETS_SEARCH_ITEM_TYPE_NEW.STORY,
  PBP: ASSETS_SEARCH_ITEM_TYPE_NEW.PBP,
  AutoVideo: ASSETS_SEARCH_ITEM_TYPE_NEW.AUTOMATIC_VIDEO,
  UserVideo: ASSETS_SEARCH_ITEM_TYPE_NEW.USER_VIDEO,
  UploadedImage: ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_IMAGE,
  ExtractedAudio: ASSETS_SEARCH_ITEM_TYPE_NEW.EXTRACTED_AUDIO,
  RecommendationVideo: ASSETS_SEARCH_ITEM_TYPE_NEW.RECOMMENDATION,
  Folder: ASSETS_SEARCH_ITEM_TYPE_NEW.FOLDER,
  ClipIt: ASSETS_SEARCH_ITEM_TYPE_NEW.CLIP_IT,
  UploadedVideo: ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_VIDEO,
  UploadedGif: ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_GIF,
  StreamSegment: ASSETS_SEARCH_ITEM_TYPE_NEW.STREAM_SEGMENT,
} as const)

export const STRING_ASSET_TYPE_BY_ASSET_TYPE = Object.freeze({
  [ASSETS_SEARCH_ITEM_TYPE_NEW.CLIP_FROM_STREAM]: 'ClipFromStream',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_CLIP]: 'UploadedClip',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_AUDIO]: 'UploadedAudio',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.EXTRACTED_IMAGE]: 'ExtractedImage',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.EXTRACTED_GIF]: 'ExtractedGif',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.GRAPHIC_IMAGE]: 'GraphicImage',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.GRAPHIC_VIDEO]: 'GraphicVideo',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.STORY]: 'Story',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.PBP]: 'PBP',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.AUTOMATIC_VIDEO]: 'AutoVideo',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.USER_VIDEO]: 'UserVideo',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_IMAGE]: 'UploadedImage',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.EXTRACTED_AUDIO]: 'ExtractedAudio',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.RECOMMENDATION]: 'RecommendationVideo',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.FOLDER]: 'Folder',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.CLIP_IT]: 'ClipIt',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_VIDEO]: 'UploadedVideo',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_GIF]: 'UploadedGif',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.STREAM_SEGMENT]: 'StreamSegment',
} as const)

export type AssetType = ValueOf<typeof ASSETS_SEARCH_ITEM_TYPE_NEW>

export const ASSETS_SEARCH_ITEM_TYPE_NEW_DISPLAY = Object.freeze({
  [ASSETS_SEARCH_ITEM_TYPE_NEW.CLIP_FROM_STREAM]: 'Clipped Video',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.CLIP_IT]: 'Clipped Video',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_CLIP]: 'Uploaded Video',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.EXTRACTED_AUDIO]: 'Extracted Audio',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.EXTRACTED_IMAGE]: 'Extracted Image',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.EXTRACTED_GIF]: 'Extracted GIF',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.GRAPHIC_IMAGE]: 'Image Graphics',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.GRAPHIC_VIDEO]: 'Video Graphics',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.STORY]: 'Story',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.PBP]: 'PBP',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.AUTOMATIC_VIDEO]: 'Automatic Video',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.USER_VIDEO]: 'User Video',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_IMAGE]: 'Uploaded Image',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_AUDIO]: 'Uploaded Audio',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.RECOMMENDATION]: 'Recommended Video',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_VIDEO]: 'Uploaded Video',
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_GIF]: 'Uploaded GIF',
} as const)

export const CTA_BUTTONS = Object.freeze({
  PUBLISH: 'PUBLISH',
  CANCEL: 'CANCEL',
  DELETE: 'DELETE',
  SAVE: 'SAVE',
})

export const BUTTON_MAIN_CTA_OPTIONS = Object.freeze({
  CREATE: 'Create',
  PUBLISH: 'Publish',
  DOWNLOAD: 'Download',
  DOWNLOAD_SOURCE_FILE: 'Download Source File',
  ADD_TO_TIMELINE: 'Add to timeline',
  SAVE: 'Save',
  Edit: 'Edit',
  DELETE: 'Delete',
  TAG_CLIP: 'Tag clip',
  DUPLICATE: 'Duplicate',
  SAVE_AND_PUBLISH: 'Save & Publish',
  CREATE_AND_PUBLISH: 'Create & Publish',
  EXTRACT_AUDIO_AS_AN_ASSET: 'Extract Audio as an Asset',
  SAVE_CHANGES: 'Save changes',
  CANCEL: 'Cancel',
} as const)

export const WORKSPACE_VIDEO_CONTEXT = Object.freeze({
  STREAM: 'stream',
  CLIP: 'clip',
  CLIP_FROM_TIMELINE: 'clip-from-timeline',
  TIMELINE: 'timeline',
  AUDIO: 'audio',
  IMAGE: 'image',
  GIF: 'gif',
  BLAZE: 'blaze',
  GRAPHICS: 'graphics',
} as const)

// Corrospondes to 'MediaSourceType' enum in Zoominsite
export const MEDIA_SOURCE_TYPE = Object.freeze({
  GAME_VIDEO: 1,
  CLIP: 2,
  VIDEO: 3,
  GRAPHIC_IMAGE: 4,
  GRAPHIC_VIDEO: 5,
  GIF: 6,
  EXTRACTED_IMAGE: 7,
  UPLOADED_IMAGE: 8,
  IMPORTED_ASSET: 9,
  VIDEO_CLIP: 10,
  MARKER: 11,
  STREAM: 12,
  GAME: 13,
  PROGRAM: 14,
  CHANNEL: 15,
} as const)

export const MEDIA_SOURCE_TYPE_BY_ASSET_TYPE = Object.freeze({
  [ASSETS_SEARCH_ITEM_TYPE_NEW.CLIP_FROM_STREAM]: MEDIA_SOURCE_TYPE.CLIP,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_CLIP]: MEDIA_SOURCE_TYPE.CLIP,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.EXTRACTED_IMAGE]: MEDIA_SOURCE_TYPE.EXTRACTED_IMAGE,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_IMAGE]: MEDIA_SOURCE_TYPE.UPLOADED_IMAGE,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.EXTRACTED_GIF]: MEDIA_SOURCE_TYPE.GIF,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_GIF]: MEDIA_SOURCE_TYPE.GIF,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.GRAPHIC_IMAGE]: MEDIA_SOURCE_TYPE.GRAPHIC_IMAGE,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.GRAPHIC_VIDEO]: MEDIA_SOURCE_TYPE.GRAPHIC_VIDEO,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.PBP]: MEDIA_SOURCE_TYPE.CLIP,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.AUTOMATIC_VIDEO]: MEDIA_SOURCE_TYPE.VIDEO,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.USER_VIDEO]: MEDIA_SOURCE_TYPE.VIDEO,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.RECOMMENDATION]: MEDIA_SOURCE_TYPE.VIDEO,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_VIDEO]: MEDIA_SOURCE_TYPE.IMPORTED_ASSET,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.CLIP_IT]: MEDIA_SOURCE_TYPE.VIDEO_CLIP,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.STREAM_SEGMENT]: MEDIA_SOURCE_TYPE.STREAM,
} as const)

// Corrospondes to 'PublishSourceType' enum values in Zoominsite
export const SOURCE_TYPE = Object.freeze({
  CLIP: 1,
  VIDEO: 2,
  EXTRACTED_GIF: 3,
  GAME_VIDEO: 6, //FullGame
  GRAPHICS_CONTENT: 7,
  STORY: 8,
  IMAGE: 12,
  UPLOADED_VIDEO: 13,
  UPLOADED_GIF: 14,
  AUDIO: 15,
  CLIP_IT: 16,
} as const)

// Corrospondes to 'PublishSourceType' enum names in Zoominsite
export const SOURCE_TYPE_ENUM = Object.freeze({
  CLIP: 'EventClip',
  VIDEO: 'VideoEdit',
  ANIMATED_GIF: 'AnimatedGif',
  GAME_VIDEO: 'FullGame',
  STORY: 'Story',
  MOMENTS: 'Moments',
  STREAM: 'Stream',
  IMAGE: 'Image',
  GRAPHICS_CONTENT: 'GraphicsContent',
  VIDEO_USER: 'VideoUser',
  FULL_STREAM_VIDEO: 'FullStreamVideo',
  UPLOADED_VIDEO: 'UploadedVideo',
  UPLOADED_GIF: 'UploadedGif',
  AUDIO: 'Audio',
  CLIP_IT: 'ClipIt',
  STREAM_SEGMENT: 'StreamSegment',
  IMPORT_STREAM: 'ImportStream',
} as const)

export const PUBLISH_FROM_TYPE = Object.freeze({
  STREAM: 1,
  CLIP: 2,
  PBP: 3,
  VIDEO: 4,
  TIMELINE: 5,
  LIBRARY: 18,
  LIBRARY_MOBILE: 20,
} as const)

export const STORY_TYPE = Object.freeze({
  AMP_HTML: 1,
  MP4: 2,
} as const)

export const CLIP_STATUS = Object.freeze({
  CREATE: 1,
  PROCESS: 2,
  SUCCESS: 3,
  NOT_SAVED: 4,
  ERROR: 5,
} as const)

export const JOB_STATUS = Object.freeze({
  UNKNOWN: -1,
  NOT_STARTED: 0,
  PENDING: 1,
  PROCESING: 2,
  SUCCESS: 3,
  ERROR: 4,
} as const)

export const ENABLE_TYPES_BY_LIBRARY = Object.freeze({
  AUTOMATIC: 'Automatic',
  MANUAL: 'Manual',
  FAST: 'Fast',
  MANUAL_AFTER_FAST: 'ManualAfterFast',
})

export const ENABLE_TYPE_STATUS = Object.freeze({
  [ENABLE_TYPES_BY_LIBRARY.AUTOMATIC]: 0,
  [ENABLE_TYPES_BY_LIBRARY.MANUAL]: 1,
  [ENABLE_TYPES_BY_LIBRARY.FAST]: 2,
  [ENABLE_TYPES_BY_LIBRARY.MANUAL_AFTER_FAST]: 3,
})

export const ASSET_STATUS = Object.freeze({
  UNKNOWN: 'Unknown',
  NOT_STARTED: 'NotStarted',
  PENDING: 'Pending',
  PROCESSING: 'Processing',
  FINISH_OK: 'FinishOK',
  FINISH_ERROR: 'FinishERROR',
} as const)

export const VIDEO_STATUS = Object.freeze({
  UNKNOWN: -1,
  PENDING: 1,
  PROCESING_PARTS: 2,
  PROCESING_FINAL: 3,
  FINISH_OK: 4,
  FINISH_ERROR: 5,
} as const)

export const EXTRACT_AUDIO_SOURCE_TYPE = Object.freeze({
  STREAM: 0,
  EVENT_CLIP: 1,
  VIDEO_USER: 2,
  VIDEO_CLIP: 3,
})

export const EXTRACT_AUDIO_SOURCE_TYPE_BY_MEDIA_TYPE = Object.freeze({
  [MEDIA_TYPES.PBP]: EXTRACT_AUDIO_SOURCE_TYPE.EVENT_CLIP,
  [MEDIA_TYPES.VIDEOS]: EXTRACT_AUDIO_SOURCE_TYPE.VIDEO_USER,
  [MEDIA_TYPES.UPLOADED_VIDEOS]: EXTRACT_AUDIO_SOURCE_TYPE.VIDEO_CLIP,
  [MEDIA_TYPES.CLIP_IT]: EXTRACT_AUDIO_SOURCE_TYPE.VIDEO_CLIP,
  [MEDIA_TYPES.ASSETS]: EXTRACT_AUDIO_SOURCE_TYPE.EVENT_CLIP,
})

export const UNTAGGED_SHOT_ACTION_ID = 1998

export const PUBLISH_POINT_NEULION_ASPERA_CATEGORIES = [
  {
    value: 'game-recaps',
    label: 'game-recaps',
  },
  {
    value: 'condensed',
    label: 'condensed',
  },
  {
    value: 'player-performances',
    label: 'player-performances',
  },
  {
    value: 'duels',
    label: 'duels',
  },
  {
    value: 'mixtapes',
    label: 'mixtapes',
  },
  {
    value: 'best-of',
    label: 'best-of',
  },
  {
    value: 'moments',
    label: 'moments',
  },
  {
    value: 'top-10',
    label: 'top-10',
  },
  {
    value: 'top-plays',
    label: 'top-plays',
  },
  {
    value: 'game-entertainment',
    label: 'game-entertainment',
  },
  {
    value: 'unpublished-stories',
    label: 'unpublished-stories',
  },
]

export const REQUEST_STATUS = Object.freeze({
  SUCCESS: 'Success',
  ERROR: 'Error',
  WAITING: 'Waiting',
  CANCELED: 'Canceled',
  PROCESSING: 'Processing',
  PROCESSING_CRITICAL_PART: 'ProcessingCriticalPart',
  SCHEDULED: 'Scheduled',
  SCHEDULED_WITH_WARNING: 'SuccessWithWarnings',
} as const)

export const MOVIE_CREATOR_VIDEO_STATUS = Object.freeze({
  RUNNING: 'Running',
  SUCCESS: 'Success',
  ERROR: 'GeneralError',
  NO_EVENTS: 'NoEvents',
  EDITOR_ERROR: 'ExceptionInSendingToEditor',
} as const)

export const AVGEN_VIDEO_STATUS = Object.freeze({
  INIT: 'Init',
  DONE: 'Done',
  ERROR: 'Error',
})

export const DRAGGABLE_SENSITIVITY_PX = 3

export const VIDEO_SCRUBBER_MAX_SCROLLS = 40

export const GRAPHICS_MEDIA_TYPE = Object.freeze({
  INTRO: 'Intro',
  OUTRO: 'Outro',
  MIDTRO: 'Midtro',
  STATIC_OVERLAY: 'StaticOverlay',
  DYNAMIC_OVERLAY: 'Overlay',
  VIDEO_OVERLAY: 'VideoOverlay',
  THUMBNAIL: 'Thumbnail',
})

export const VIDEO_CHANNEL_ITEM_TYPE = Object.freeze({
  STATIC_OVERLAY: 'StaticOverlay',
  DYNAMIC_OVERLAY: 'DynamicOverlay',
  EXTERNAL_AUDIO_TRACK: 'ExternalAudioTrack',
  MASTER_CHANNEL_AUDIO_TRACK: 'MasterChannelAudioTrack',
  CLOSED_CAPTIONS_TRACK: 'closedCaptionsTrack',
  CLEAN_CANVAS_OVERLAY: 'CleanCanvasImageOverlay',
} as const)

export const OVERLAY_LOOP_TYPE = Object.freeze({
  ONCE: 'Once',
  FOREVER: 'Forever',
} as const)

export const OVERLAY_PLAY_END_TYPE = Object.freeze({
  FREEZE: 'FreezeFrame',
  FADE_OUT: 'Hide',
} as const)

export const WSC_APPLICATION_TYPE = Object.freeze({
  AVGEN: 0,
  CLIPRO: 1,
  GRAPHICS_ENGINE: 2,
  GAME_TAGGER: 3,
  MULTI_TAGGERL: 4,
  OLD_GAME_TAGGER: 6,
  CROPOTI: 14,
} as const)

export const MINIMUM_DELAY_FOR_SHOWING_MESSAGE_AFTER_ACTIONS = 1250

export const CLIPRO_APP_NAME = 'clipro'

export const AVGEN_APP_NAME = 'avgen'

export const GRAPHICS_APP_NAME = 'graphics'

export const BQ_APP_NAME = 'bqpanel'

export const LIBRARY_APP_NAME = 'library'

export const PARTNERS_PORTAL_APP_NAME = 'partners-portal'

export const LOGIN_APP_NAME = 'login'

export const PUBLISH_HUB_APP_NAME = 'publish-hub'

export const ENVIRONMENTS = Object.freeze({
  PROD: 'prod',
  DEV: 'dev',
  UAT: 'uat',
  PR: 'pr',
  STAGING: 'staging',
} as const)

export const BOOKMARK_TAG_NAME = 'FanduelPush'

export const DEFAULT_THUMBNAIL_ERROR_MESSAGE = 'The thumbnail you selected is not available'

export const BACKOFFICE_WEBSITES = ['mamba', 'fast-mamba', 'backoffice']

export const PERMISSION_TYPE = Object.freeze({
  BACKOFFICE: 'Backoffice',
  INTERNAL: 'Internal',
} as const)

export const CHANNEL = Object.freeze({
  MASTER_CHANNEL_VIDEO_TRACK: 'Video',
  MASTER_CHANNEL_AUDIO_TRACK: 'Interleaved Audio',
  DYNAMIC_OVERLAY: 'Graphics',
  EXTERNAL_AUDIO_TRACK: 'External Audio',
  CLOSED_CAPTIONS_TRACK: 'Closed Captions',
} as const)

export const TRACKER_CONTEXT_COMMON = Object.freeze({
  SIDE_PANEL: 'sidepanel',
  SIDE_BAR_MENU: 'side bar menu',
  MY_PROFILE: 'My_profile',
  USER_MANAGEMENT: 'User_management',
  LOGIN: 'Log in',
  DIALOG: 'dialog',
})

export const TRACKER_SUB_CONTEXT_COMMON = Object.freeze({
  PUBLISH: 'publish',
  SYSTEM_MENU: 'system menu',
  PREFERENCES_MENU: 'preferences menu',
  CONTACT_US_FORM: 'contact us form',
  USERS: 'Users',
  INVITATIONS: 'Invitations',
  GROUPS: 'Groups',
  PERSONAL_INFO: 'Personal_Info',
  TOAST_ACTION: 'toast_action',
  PAGE_MANAGEMENT: 'page_management',
  CHIP_ACTION: 'chip_action',
})

export const TRACKER_SUB_CONTEXT = Object.freeze({
  ...TRACKER_SUB_CONTEXT_COMMON,
  BLAZE: 'blaze',
})

export const COOKIE_AUTH_SITES = [
  'clipro',
  'avgen',
  'graphics',
  'login',
  'mamba',
  'fast-mamba',
  'backoffice',
]

export const DATE_FORMAT_CONFIG = Object.freeze({
  YEAR: 'numeric',
  MONTH: '2-digit',
  DAY: '2-digit',
} as const)

export const TIME_FORMAT_CONFIG = Object.freeze({
  HOUR: '2-digit',
  MINUTE: '2-digit',
} as const)

export const LOCALES_LANGAUGE = Object.freeze({
  EN_US: 'en-US',
  EN_GB: 'en-GB',
  EN_ZA: 'en-ZA',
} as const)

export const DATE_FORMATS = Object.freeze({
  MDY: 'MM/DD/YYYY',
  DMY: 'DD/MM/YYYY',
  YMD: 'YYYY/MM/DD',
} as const)

export const DATE_PICKER_DATE_FORMATS = Object.freeze({
  MDY: 'MM/dd/yyyy',
  DMY: 'dd/MM/yyyy',
  YMD: 'yyyy/MM/dd',
} as const)

export const JOB_REQUEST_STATUS = Object.freeze({
  SUCCESS: 'FinishOK',
  ERROR: 'FinishERROR',
  NOT_STARTED: 'NotStarted',
  UNKNOWN: 'Unknown',
  PROCESSING: 'Procesing',
  PENDING: 'Pending',
} as const)

export const FADE_INS = Object.freeze([
  { label: 'None', value: 'None' },
  { label: 'White Flash', value: 'WhiteFlash' },
  { label: 'Black Flash', value: 'BlackFlash' },
] as const)

export const FADE_OUTS = Object.freeze([
  { label: 'None', value: 'None' },
  { label: 'Short Fade Out', value: 'FadeToBlackShort' },
  { label: 'Long Fade Out', value: 'FadeToBlackLong' },
] as const)

export const TRANSITIONS = Object.freeze([
  { label: 'None', value: 'None' },
  { label: 'Cross Fade', value: 'Fade' },
  { label: 'White Flash', value: 'WhiteFlash' },
  { label: 'Black Flash', value: 'BlackFlash' },
] as const)

export const TRACKER_PRODUCT = Object.freeze({
  CLIPRO: 'Clipro',
  AVGEN: 'AVGen',
  GRAPHICS_IN_STUDIO: 'GraphicsInStudio',
  GRAPHICS: 'GE',
  SETTINGS: 'Settings',
  CMS: 'Cms',
  LIBRARY: 'library',
  PUBLISH_HUB: 'PublishHub',
  LIBRARY_MOBILE: 'library mobile',
  CREATE: '2024 Create',
} as const)

export const TRACKER_TEXT_LABEL = Object.freeze({
  CLIPRO: 'Clipro',
  AVGEN: 'AVGen',
  GRAPHICS: 'GE',
  SETTINGS: 'Settings',
  CMS: 'Cms',
  LIBRARY: 'Library',
  UPDATE_PERSONAL_INFO: 'Update personal info',
  UPDATE_PROFILE_PICTURE: 'Update profile picture',
  REMOVE_PROFILE_PICTURE: 'Remove profile picture',
  UPDATE_PASSWORD: 'Update password',
  EDIT_PASSWORD: 'Edit password',
  GROUP_AND_ROLES: 'Groups & Roles',
  EDIT_PROFILE_PICTURE: 'Edit profile picture',
  ADD_USERS_TO_GROUP: 'Add users to group',
  REMOVE_USERS_FROM_GROUP: 'Remove users from group',
  REMOVE_USER_FROM_GROUP: 'Remove user from group',
  DEACTIVATE: 'Deactivate users',
  ACTIVATE: 'Activate users',
  ADD_USERS: 'Add users',
  SEARCH_GROUPS: 'Search groups',
  DELETE_USER: 'Delete user',
  GO_TO_USER: 'Go to user',
  RESEND: 'Resend',
  INVITE_NEW_USER: 'Invite new user',
  INVITE_MORE_USER: 'Invite more users',
  OK: 'Ok',
  RESET_PASSWORD_VIA_EMAIL: 'Reset password via email',
  RECENT_SEARCHES: 'recent_searches',
  ASSET_ENGAGEMENT: 'asset_engagement',
  SHOW_MORE: 'show_more',
  FILTER: 'filter',
  BACKWARD: 'Backward',
  FORWARD: 'Forward',
  SELECTED: 'selected',
  DESELECTED: 'deselected',
  MORE_OPTIONS: 'More options',
} as const)

export const TRACKER_INTERACTION_TYPE = Object.freeze({
  CLICK: 'Click',
  RIGHT_CLICK: 'Right-click',
  DOUBLE_CLICK: 'Double-click',
  KEYBOARD: 'Keyboard',
  HOVER: 'Hover',
  DRAG: 'Drag',
  FOCUS: 'Focus',
  BLUR: 'Blur',
  SCROLL: 'Scroll',
  WRITE: 'Write',
} as const)

export const TRACKER_ACTION_NAME = Object.freeze({
  ADD: 'Add',
  SET: 'Set',
  CANCEL: 'Cancel',
  CHANGE: 'Change',
  CHECKED: 'Checked',
  CLICK: 'click',
  CHECK: 'Check',
  UNCHECK: 'Uncheck',
  CLOSE: 'Close',
  RESET: 'Reset',
  DELETE: 'Delete',
  DESELECT: 'Deselect',
  EXPAND: 'Expand',
  INSERT: 'Insert',
  LOAD: 'Load',
  MOVE: 'Move',
  OPEN: 'Open',
  PLAY: 'Play',
  PREVIEW: 'Preview',
  REORDER: 'reorder',
  SELECT: 'Select',
  SUBTRACT: 'Subtract',
  ZOOM_OUT: 'Zoom-out',
  ZOOM_IN: 'Zoom-in',
  TRIM_BEGIN: 'Trim_begin',
  TRIM_END: 'Trim_end',
  UPDATE: 'Update',
  SIDE_EFFECT: 'side-effect',
  RESIZE: 'Resize',
  SPLIT: 'Split',
  COLLAPSE: 'collapse',
  FORWARD: 'forward',
  BACKWARD: 'backward',
  STOP: 'stop',
  SEND: 'Send',
  SHOW_TOOLTIP: 'Show_tooltip',
  REMOVE: 'Remove',
  APPROVE_REMOVAL: 'approve_removal',
  CANCEL_REMOVAL: 'cancel_removal',
  CREATE: 'create',
  GENERATE: 'generate',
  MODIFY: 'modify',
  EDIT_TEXT: 'Edit_text',
  UPLOAD: 'upload',
  INSERT_LINK: 'insertLink',
  FILTER: 'Filter',
  SEARCH: 'Search',
  REVOKE: 'Revoke',
  RETRY_AUDIO_SCAN: 'retryAudioScan',
  WRITE: 'Write',
} as const)

export const TRACKER_FIELD_NAME = Object.freeze({
  COLOR: 'color',
  SIZE: 'size',
  SCALE: 'scale',
  MOVE: 'move',
  TEXT_VALUE: 'text_value',
} as const)

export const TRACKER_EVENT_COMMON = Object.freeze({
  SIDE_BAR_MENU: 'side_bar_menu',
  NAVIGATION_EVENT: 'navigation_event',
  SYSTEM_MENU_ENGAGEMENT: 'system_menu_engagement',
  GROUPS_SYSTEMS_SWITCH: 'groups_systems_switch',
  FAVORITES_MANAGEMENT: 'favorites_management',
  PREFERENCES_MENU_ENGAGEMENT: 'preferences_menu_engagement',
  UPLOAD_MONITOR_MENU_ENGAGEMENT: 'upload_monitor_menu_engagement',
  SUPPORT_ENGAGEMENT: 'support_engagement',
  CTA_BUTTON: 'cta_button',
  PUBLISH_SETTINGS_ENGAGEMENT: 'publish_settings_engagement',
  SHARE_SETTINGS_ENGAEGEMENT: 'share_settings_engagement',
  SIDE_PANEL_NAVIGATION_EVENT: 'sidepanel_navigation_event',
  TOAST_BUTTON_CLICK: 'toast_button_click',
  BEAMER_BUTTON_CLICK: 'beamer_button_click',
} as const)

export const TRACKER_EVENT_NEW_CREATE = Object.freeze({
  MAIN_FLOW_SELECTION: 'main_flow_selection',
  SUBJECT_TYPE_SELECTION: 'subject_type_selection',
  PREFERENCES_NAVIGATION: 'preferences_navigation',
  EXIT_POPUP_EVENT: 'exit_popup_event',
  EXIT_EVENT: 'exit_event',
  VIDEO_CONTENT_NAVIGATION: 'video_content_navigation',
  SEARCH_EVENT: 'search_event',
} as const)

export const TRACKER_CLICK_TYPE = Object.freeze({
  KEBAB_MENU: 'Kebab menu',
  RIGHT_CLICK: 'Right-click',
} as const)

export const TRACKER_SOURCE_TYPE = Object.freeze({
  ...SOURCE_TYPE_ENUM,
  GRAPHICS: 'Graphics',
  ASSETS: 'Assets',
  GRAPHIC: 'Graphic',
  TEMPLATE: 'Template',
  STORY: 'Story',
  STORY_PAGE: 'Story_Page',
  CLOSED_CAPTIONS: 'Closed_Captions',
  SETTINGS: 'Settings',
} as const)

export const TIME_PARTS_TYPE = Object.freeze({
  HOURS: 'hours',
  MINUTES: 'minutes',
  SECONDS: 'seconds',
  DECIMALS: 'decimals',
  MILLISECONDS: 'milliseconds',
} as const)

export const TIME_INPUT_SIDE = Object.freeze({
  IN: 'time-input-in',
  OUT: 'time-input-out',
})

export const VIDEO_ASSET_TYPE = Object.freeze({
  UNKNOWN: 'Unknown',
  VIDEO_EVENT_CLIP: 'VideoEventClip',
  VIDEO_CLIP: 'VideoClip',
  VIDEO_SEGMENT: 'VideoSegment',
  VIDEO_STREAM_SEGMENT: 'VideoStreamSegment',
  VIDEO_GRAPHIC: 'VideoGraphic',
  VIDEO_EXTRACTED_IMAGE: 'VideoExtractedImage',
  VIDEO_UPLOADED_IMAGE: 'VideoUploadedImage',
  STREAM: 'Stream',
} as const)

export const VIDEO_ASSET_TYPE_BY_ASSET_TYPE = Object.freeze({
  [ASSETS_SEARCH_ITEM_TYPE_NEW.CLIP_IT]: VIDEO_ASSET_TYPE.VIDEO_CLIP,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_VIDEO]: VIDEO_ASSET_TYPE.VIDEO_CLIP,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.CLIP_FROM_STREAM]: VIDEO_ASSET_TYPE.VIDEO_EVENT_CLIP,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_CLIP]: VIDEO_ASSET_TYPE.VIDEO_EVENT_CLIP,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.EXTRACTED_IMAGE]: VIDEO_ASSET_TYPE.VIDEO_EXTRACTED_IMAGE,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_IMAGE]: VIDEO_ASSET_TYPE.VIDEO_UPLOADED_IMAGE,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.GRAPHIC_VIDEO]: VIDEO_ASSET_TYPE.VIDEO_GRAPHIC,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.GRAPHIC_IMAGE]: VIDEO_ASSET_TYPE.VIDEO_GRAPHIC,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.PBP]: VIDEO_ASSET_TYPE.VIDEO_EVENT_CLIP,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.AUTOMATIC_VIDEO]: VIDEO_ASSET_TYPE.VIDEO_EVENT_CLIP,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.USER_VIDEO]: VIDEO_ASSET_TYPE.VIDEO_EVENT_CLIP,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.STREAM_SEGMENT]: VIDEO_ASSET_TYPE.VIDEO_STREAM_SEGMENT,
} as const)

export const OPEN_PREFERENCES_MODAL_QUERY_PARAM = 'openPreferencesModal'
export const PAGE_QUERY_PARAM = 'page'

export const SIDEBAR_WIDTH_IN_PX_DEPRECATED = 55
export const SIDEBAR_WIDTH_IN_PX = 65

export const CREATE_STORY_QUERY_PARAM = 'createStory'
export const CREATE_MOMENT_QUERY_PARAM = 'createMoment'

export const TEMPLATES_SORT_DIRECTIONS = Object.freeze({
  ASCENDANT: 'Asc',
  DESCENDANT: 'Desc',
})

export const WIDGET_DATA_ORIGINS = Object.freeze({
  AUTO: 'Auto',
  CLIENT: 'Client',
})

export const IS_SHOW_GAME_MODAL_AT_APP_INIT_QUERY_PARAM = 'isShowGameModalAtAppInit'

export const MUSIC_RIGHTS_STATUS = Object.freeze({
  MATCH: 'MatchFound',
  LIKELY_MUSIC: 'LikelyMusic',
  NO_MATCH: 'NoMatch',
} as const)

export const MUSIC_RIGHTS_NO_DATA = 'No further data is available'

export const MUSIC_RIGHTS_SEE_MORE = ' See more'

export const MUSIC_RIGHTS_REQUIRED_METADATA = Object.freeze({
  title: 'Title',
  artist: 'Artist',
  iSRC: 'ISRC',
  label: 'Label',
  vendor: 'Vendor',
})

export const MUSIC_RIGHTS_PARAMS = {
  FULL_MATCH: {
    COLOR: '#ff364e',
    PRIMARY_TEXT: 'Music detected',
    BODY_TEXT: 'Replace flagged music with generic crowd noise',
  },
  MUSIC_REPLACED: {
    COLOR: '#00B27C',
    PRIMARY_TEXT: 'Music stripped',
    BODY_TEXT: 'Commentary is unchanged',
  },
  MUSIC_REPLACED_WITHOUT_VIOLATION: {
    COLOR: '#00B27C',
    PRIMARY_TEXT: 'Sound replaced',
    BODY_TEXT: 'Original sound replaced with crowd noise',
  },
  PARTIAL_MATCH: {
    COLOR: '#ffae00',
    PRIMARY_TEXT: 'Sound detected',
    BODY_TEXT: '',
  },
  PROCESSING: {
    COLOR: '#FFFFFF',
    PRIMARY_TEXT: 'Scanning in progress',
    BODY_TEXT: 'Scanning in progress, it will take up to 30 seconds',
  },
  SCANNING_FAILED: {
    COLOR: '#FFFFFF',
    PRIMARY_TEXT: 'Scanning failed',
    BODY_TEXT: 'Failed to scan, please try again',
  },
}

export const STRIP_MUSIC_LABEL = 'Strip music'
export const REVERT_CHANGES_LABEL = 'Revert changes'

export const SESSION_STORAGE_HIDE_GAMES_TABLE = 'hideGamesTable'

export const SOURCE_TYPE_BY_ASSET_TYPE = Object.freeze({
  [ASSETS_SEARCH_ITEM_TYPE_NEW.CLIP_FROM_STREAM]: SOURCE_TYPE_ENUM.CLIP,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_CLIP]: SOURCE_TYPE_ENUM.CLIP,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.EXTRACTED_AUDIO]: SOURCE_TYPE_ENUM.AUDIO,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.EXTRACTED_IMAGE]: SOURCE_TYPE_ENUM.IMAGE,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.EXTRACTED_GIF]: SOURCE_TYPE_ENUM.ANIMATED_GIF,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.GRAPHIC_IMAGE]: SOURCE_TYPE_ENUM.GRAPHICS_CONTENT,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.GRAPHIC_VIDEO]: SOURCE_TYPE_ENUM.GRAPHICS_CONTENT,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.STORY]: SOURCE_TYPE_ENUM.STORY,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.PBP]: SOURCE_TYPE_ENUM.CLIP,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.AUTOMATIC_VIDEO]: SOURCE_TYPE_ENUM.VIDEO,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.USER_VIDEO]: SOURCE_TYPE_ENUM.VIDEO,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.RECOMMENDATION]: SOURCE_TYPE_ENUM.VIDEO,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_IMAGE]: SOURCE_TYPE_ENUM.IMAGE,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_AUDIO]: SOURCE_TYPE_ENUM.AUDIO,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_VIDEO]: SOURCE_TYPE_ENUM.UPLOADED_VIDEO,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.UPLOADED_GIF]: SOURCE_TYPE_ENUM.UPLOADED_GIF,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.CLIP_IT]: SOURCE_TYPE_ENUM.CLIP_IT,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.STREAM_SEGMENT]: SOURCE_TYPE_ENUM.STREAM_SEGMENT,
} as const)

// This type is incomplete. It's used for excluding asset types on publish
export const MEDIA_TYPE_BY_ASSET_TYPE = Object.freeze({
  [ASSETS_SEARCH_ITEM_TYPE_NEW.GRAPHIC_IMAGE]: MEDIA_TYPES.GRAPHIC_IMAGES,
  [ASSETS_SEARCH_ITEM_TYPE_NEW.GRAPHIC_VIDEO]: MEDIA_TYPES.GRAPHIC_VIDEOS,
} as const)

export const TRACKER_LOGIC_TYPE_DEFAULT = 'default'

export const CLOCK_00_00 = '00:00'

export const GAME_SCORE_NA = 'N/A'

export const AUTOMATION_ROLE_ID = 4

export const BLANK_WHITE_IMAGE_ID_FOR_STORY_MODE = 328272

export const WSC_NEW_FAVICON =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACxSURBVHgB7VKxDcIwELwwAGIBJHoaWjqmoKaAHpEBCBN4BBiACWho6ShTpkqdET65RI5jx1EKF2ny0sk+6/5OfjvKBYKAWiCwpjcAZ0DsD/UsatwSyOVq+Lna/zLI8QRZbxrovtaAAt2wXDWcqz77/E2QenkMCCZ3Ux/KcDZSEydG3zNICzv1/YVsdzanZtCAcFPZpDnvPmrgDtTlnE1X633G+G5z9QSqq3krmr9yuEEJ7BrO4vzllP4AAAAASUVORK5CYII='

export const CURRENT_TIME_SAFETY_MARGIN = 0.001

export const SETTINGS_KEYS_TO_GET_BY_SYSTEM = {
  MULTI_PARTICIPANTS: 'multiParticipants',
  TOURNAMENT: 'tournament',
  SHOW_PROGRAMS_FILTER: 'showProgramsFilter',
  PARAMETER_SETS: 'parameterSets',
  TEAM_UI_NAME: 'teamUIName',
  GAME_UI_NAME: 'gameUIName',
  PLAYER_UI_NAME: 'playerUIName',
}

export const ADDITIONAL_PLAYER_TYPE = Object.freeze({
  SPEAKER: 'Speaker',
  MENTIONED: 'Mentioned',
} as const)

export const SHORT_REPLAY_NAME = 'Short'

export const SLOW_MOTION_REPLAY_NAME = 'Slow Motion'

export const DEFAULT_DEBOUNCE_DELAY = 1000

export const COMPRESSION_SIZE = Object.freeze({
  ORIGINAL: 0,
  LARGE: 1,
  MEDIUM: 2,
  SMALL: 3,
} as const)

export type CompressionSize = ValueOf<typeof COMPRESSION_SIZE>

export const COMPRESSION_SIZE_DISPLAY = Object.freeze({
  [COMPRESSION_SIZE.LARGE]: 'large',
  [COMPRESSION_SIZE.MEDIUM]: 'medium',
  [COMPRESSION_SIZE.SMALL]: 'small',
  [COMPRESSION_SIZE.ORIGINAL]: 'original',
} as const)

/**
 * AUDIO: Audio only asset
 * IMAGE: Static or dynamic image (.gif) asset
 * VIDEO: Video only or video + audio asset
 **/
export const ASSET_PRIMITIVE_KIND = Object.freeze({
  AUDIO: 'Audio',
  IMAGE: 'Image',
  VIDEO: 'Video',
} as const)

export type AssetPrimitiveKind = (typeof ASSET_PRIMITIVE_KIND)[keyof typeof ASSET_PRIMITIVE_KIND]

export const ASSET_RATIO_ORIENTATION = Object.freeze({
  /**
   * Asset width >= height
   **/
  LANDSCAPE: 'LANDSCAPE',

  /**
   * Asset height > width
   **/
  PORTRAIT: 'PORTRAIT',
} as const)

export type AssetRatioOrientation =
  (typeof ASSET_RATIO_ORIENTATION)[keyof typeof ASSET_RATIO_ORIENTATION]

export const ASPECT_RATIO_TO_DISPLAY_ORIENTATION: Readonly<
  Record<
    (typeof ASPECT_RATIO)[keyof typeof ASPECT_RATIO],
    (typeof ASSET_RATIO_ORIENTATION)[keyof typeof ASSET_RATIO_ORIENTATION]
  >
> = Object.freeze({
  [ASPECT_RATIO.HORIZONTAL]: ASSET_RATIO_ORIENTATION.LANDSCAPE,
  [ASPECT_RATIO.SQUARE]: ASSET_RATIO_ORIENTATION.LANDSCAPE,
  [ASPECT_RATIO.FOUR_TO_FIVE]: ASSET_RATIO_ORIENTATION.PORTRAIT,
  [ASPECT_RATIO.VERTICAL]: ASSET_RATIO_ORIENTATION.PORTRAIT,
  [ASPECT_RATIO.TWO_TO_THREE]: ASSET_RATIO_ORIENTATION.PORTRAIT,
  [ASPECT_RATIO.THREE_TO_FOUR]: ASSET_RATIO_ORIENTATION.PORTRAIT,
  [ASPECT_RATIO.FOUR_TO_THREE]: ASSET_RATIO_ORIENTATION.LANDSCAPE,
  [ASPECT_RATIO.TWO_TO_ONE]: ASSET_RATIO_ORIENTATION.LANDSCAPE,
  [ASPECT_RATIO.ONE_TO_TWO]: ASSET_RATIO_ORIENTATION.PORTRAIT,
  [ASPECT_RATIO.SEVEN_TO_EIGHT]: ASSET_RATIO_ORIENTATION.PORTRAIT,
  [ASPECT_RATIO.EIGHT_TO_SEVEN]: ASSET_RATIO_ORIENTATION.PORTRAIT,
  [ASPECT_RATIO.THREE_TO_ONE]: ASSET_RATIO_ORIENTATION.LANDSCAPE,
  [ASPECT_RATIO.THREE_TO_TWO]: ASSET_RATIO_ORIENTATION.LANDSCAPE,
  [ASPECT_RATIO.ONE_TO_THREE]: ASSET_RATIO_ORIENTATION.PORTRAIT,
})

export interface RequestOptions {
  method?: 'POST' | 'GET' | 'PUT' | 'DELETE'
  queryParams?: Record<string, any>
  body?: any
  signal?: AbortSignal
  headers?: Record<string, string>
  preventErrorLogging?: boolean
  isNotUserInteractiveRequest?: boolean
  asText?: boolean
}

export type FetcherType = (path: string, options: RequestOptions) => Promise<any>
